module.exports = __webpack_public_path__ + "img/Denis-Casey.9b8f0b57.jpg";